import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Pipe({
  name: 'sanitizeHtml',
  pure: true
})
export class SanitizeHtmlPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(value: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(
      DOMPurify.sanitize(value ?? '', {
        // DOMPurify drops target by default, and links from backed-up content would then navigate the app away
        ADD_ATTR: ['target'],
        // allowed by DOMPurify, but backed-up content never has forms: here they could only be a phishing form inside the app
        FORBID_TAGS: ['form', 'input', 'button', 'select', 'textarea']
      })
    );
  }
}
